import React from "react";
//import "./Pages.css";

function About() {
  return (
    <div className="page-container">
      <h1>About Vortex Network</h1>
      <p>
        Welcome to Vortex Network! Our mission is to create a futuristic, 
        interactive gaming experience for everyone. Explore our games, 
        connect with the community, and enjoy a seamless network experience.
      </p>
    </div>
  );
}

export default About;
